<template>
  <v-container>

    <v-row>
      <v-col cols="6">
        
        <h3>Extractos</h3>
        <v-data-table 
          :items="extractos" 
          :headers="extractoHeaders" 
          item-key="id" 
          dense
          @click:row="seleccionarExtracto"
          :item-class="(item) => (item.id === extractoSeleccionado?.id ? 'selected-row' : '')"
          />
      </v-col>

      <v-col cols="6">
        <h3>Recibos</h3>
        <v-data-table :items="recibos" :headers="reciboHeaders" item-key="id" dense show-select
          v-model="recibosSeleccionados" />
        <v-btn color="primary" :disabled="!extractoSeleccionado || recibosSeleccionados.length === 0"
          @click="conciliar">
          Conciliar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import axios from 'axios'

export default {
  data() {
    return {
      extractos: [],
      recibos: [],
      extractoSeleccionado: null,
      recibosSeleccionados: [],

      extractoHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Banco', value: 'banco' },
        { text: 'Cuenta', value: 'nroCuenta' },
        { text: 'Fecha', value: 'fechaMovimiento' },
        { text: 'Monto', value: 'credito' },
      ],

      reciboHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Nro Recibo', value: 'nroRecibo' },
        { text: 'Fecha', value: 'fechaEmision' },
        { text: 'Monto', value: 'monto' },
      ],
    }
  },
  methods: {
    async cargarDatos() {
      // const res1 = await axios.get('/api/extractos/pendientes')
      // this.extractos = res1.data
      const extractoData = [
        {
          id: 1,
          banco: "Banco Unión",
          nroCuenta: "1234567890",
          fechaMovimiento: "2025-07-01",
          credito: 1500.75
        },
        {
          id: 2,
          banco: "Banco Mercantil",
          nroCuenta: "9876543210",
          fechaMovimiento: "2025-07-02",
          credito: 2350.00
        },
        {
          id: 3,
          banco: "Banco BISA",
          nroCuenta: "1122334455",
          fechaMovimiento: "2025-07-03",
          credito: 500.25
        }
      ];
      this.extractos = extractoData;

      // const res2 = await axios.get('/api/recibos/pendientes')
      // this.recibos = res2.data
      const reciboData = [
        {
          id: 101,
          nroRecibo: "RC-0001",
          fechaEmision: "2025-07-01",
          monto: 1500.00
        },
        {
          id: 102,
          nroRecibo: "RC-0002",
          fechaEmision: "2025-07-02",
          monto: 1800.50
        },
        {
          id: 103,
          nroRecibo: "RC-0003",
          fechaEmision: "2025-07-03",
          monto: 1250.75
        }
      ];
      this.recibos=reciboData;

    },
    seleccionarExtracto(extracto) {
      this.extractoSeleccionado = extracto
    },
    async conciliar() {
      const payload = {
        extractoId: this.extractoSeleccionado.id,
        recibos: this.recibosSeleccionados.map(r => ({
          id: r.id,
          monto: r.monto,
        })),
      }
      window.console.log(payload)

     // await axios.post('/api/conciliar', payload)
      this.extractoSeleccionado = null
      this.recibosSeleccionados = []
      this.cargarDatos()
    },
  },
  mounted() {
    this.cargarDatos()
  },
}
</script>
<style >
.selected-row {
  background-color: #e3f2fd !important; /* azul clarito */
  /* background: darkblue; */
}
</style>